(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SO-articles-collection"] && !Shopify.designMode) return;
  try {
    
    $('.articles__container h3').click(function(e) {
        const selector = $(this).data('element');
        const div_height = $(`.${selector}`).height();

        if(div_height === 0) {
            $(this).find('.arrow-closed').addClass('arrow-open');
            $(this).find('.arrow-closed').removeClass('arrow-closed');
            $(`.${selector}`).height('auto');
            
        } else {
            $(this).find('.arrow-open').addClass('arrow-closed');
            $(this).find('.arrow-open').removeClass('arrow-open');
            $(`.${selector}`).height(0);
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SO-banner-collection"] && !Shopify.designMode) return;
  try {
    
    const product_carousel = {
        changeSlider: (reversa) => {
            reversa = typeof(reversa) === 'boolean' ? reversa : false;

            const total_blocks = $('.So-slider__item').length;
            const visible_block = $('.So-slider__item:visible');
            let visible_position = visible_block.data('position');

            if(reversa){
                visible_position = visible_position - 1 <= 0 ? total_blocks : visible_position - 1;
                
            } else {
                visible_position = visible_position + 1 > total_blocks ? 1 : visible_position + 1;
            }

            visible_block.fadeOut(1000, "linear", () => {
                $(".So-slider__item[data-position='"+visible_position+"']").fadeIn(1000);
            });
        },
    };

    setInterval(e=>{
        product_carousel.changeSlider();
    }, 7500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SO-gwp-template"]) return;
  try {
    
$(document).ready(function () {

  var loadGift = setInterval(function () {

    clearInterval(loadGift);
      var gifts = Shopify.cart;
      var result = '';
      $.ajax({
        type: "POST",
        url: "https://mexicoapi.servicios-sodigitalglobal.com/update-cart",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(gifts),
        success: function (resp) {
          result = resp;

          var elements = [];
          var ind = 0;
          var elemento = '';



          for (let i in resp) {
            if (resp[i] && resp[i].id !== undefined) {
              elemento = '<div class="velaProBlock proFlyBlock multiple_image" data-price="' + resp[i].variants[0].price + '">' +
                '<div class="product-outline enf-slider">' +

                '<div class="proHImage">' +
                '<a class=\"proFeaturedImage\" href=\"products/' + resp[i].handle + ' " tabindex="0">' +
                '<span>' +
                '<img ' +
                ' class="img-responsive js lazyautosizes ls-is-cached lazyloaded enf_img_prev"' +
                ' datasrc=\"' + resp[i].image.src + ' \" ' +
                ' data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
                ' data-sizes="auto"' +
                ' alt=\"' + resp[i].title + '\"' +
                ' src=\"' + resp[i].image.src + ' \" ' +
                ' sizes="216px"' +
                ' />' +
                '<noscript>' +
                '<img class="img-responsive" alt=\"' + resp[i].title + '\" src=\"' + resp[i].image.src + ' \"" />' +
                '</noscript>' +
                '</span>' +
                '<img' +
                ' class=\" img-responsive imgFlyCart image-primay js lazyautosizes ls-is-cached lazyloaded\" ' +
                ' datasrc=\"' + resp[i].image.src + ' \" ' +
                ' data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                ' data-sizes="auto" ' +
                ' alt=\"' + resp[i].title + '\"' +
                ' src=\"' + resp[i].image.src + ' \"' +
                ' sizes="216px" ' +
                ' />' +
                '</a>' +
                '<p class="proAttr instock hidden">En stock</p>' +
                '</div>' +
                '<div class="proContent">' +
                '<h5 class="proName">' +
                '<a href=\"products/' + resp[i].handle + '\" tabindex=\"0\">' + resp[i].title + '</a>' +
                '</h5>' +
                '<div class="proPrice">' +
                '<div class="priceProduct priceSale">$ ' + resp[i].variants[0].price + '</div>';

              if (resp[i].variants[0].compare_at_price !== null) {
                elemento += '<div class="priceProduct priceCompare">$  ' + resp[i].variants[0].compare_at_price + '</div>'
              }
              elemento += '</div>' +
                '<div class="velaSwatchCus"></div>' +
                '</div>' +
                '<div class="formAddToCart ' + resp[i].variants[0].id + ' enf__form__sl">' +
                '<input type="hidden" name="id" value="' + resp[i].variants[0].id + '" tabindex="0" />';

              if (parseInt(resp[i].variants[0].inventory_quantity, 10) > 0) {

                elemento += '<div class="velaJsQty">' +
                  '<button type="button" class="velaQtyAdjust velaQtyAdjustMinus" data-id="" data-qty="0" tabindex="0">' +
                  '<span class="txtFallback">−</span>' +
                  '</button>' +
                  '<input type=\"text\" class=\"velaQtyNum\" value=\"1\" min=\"1\" data-id=\"\" aria-label=\"quantity\" name=\"updates[]\" tabindex=\"0\" />' +
                  '<button type="button" class="velaQtyAdjust velaQtyAdjustPlus" data-id="" data-qty="11" tabindex="0">' +
                  '<span class="txtFallback">+</span>' +
                  '</button>' +
                  '</div>' +
                  '<button class="btn  enf__add__cart btnAddToCart" type="button" tabindex="0" data-id-cart="' + resp[i].variants[0].id + '">' +
                  '<i class="ion ion-android-add"></i>' +
                  '<span>Agregar al gifts</span>' +
                  '</button>'
              } else {
                elemento +=
                  '<button class="btn btnAddToCart disabled" type="button" tabindex="0">' +
                  '<i class="ion ion-android-add"></i>' +
                  '<span>Agotado</span>' +
                  '</button>';
              }
              elemento +=
                '</div>' +
                '</div>' +
                '</div>';
              $('#featuredProducts').slick('slickAdd', $.parseHTML('<div class="product-item ">' + elemento + '</div>'));
            } //end if        
          } //endfor
        },
        error: function (resp) {
        }
      });
      return false;
  }, 50);

  $('html').on('click', '.enf__form__sl .enf__add__cart', function () {
    var cant = parseInt($(this).closest('.velaProBlock').find('.velaQtyNum').val());
    var idProd = $(this).attr('data-id-cart')
    var params = {
      type: 'post',
      url: '/cart/add.js',
      data: {
        id: idProd,
        quantity: cant
      },
      complete: function () {
        window.location.reload(true);
      }
    };
    jQuery.ajax(params);
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-type-1-styles"]) return;
  try {
    
$('.enfa_question').append(`<span class="op_plus">+</span><span class="op_minus">-</span>`);

$('.enfa_question').click(function(e){
  e.preventDefault();
  const siblings = $(this).siblings();
  let show_answer = siblings.css('display') === 'none';
  
  $('.enfa_answer').hide()
  $('.enfa_question').children('.op_minus').hide();
  $('.enfa_question').children('.op_plus').show();

  if(show_answer) {
    $(this).parent().children('.enfa_answer').toggle('slow');
    $(this).children('.op_plus').hide();
    $(this).children('.op_minus').show();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculadora-formula"]) return;
  try {
    

    (function ($) {
     $.fn.calculator = function () {
        var title = $(this).find("div.products > div.text > h2").text();

        $(this).find(".cart").click((e)=>{
          var id = $(this).find("div.noTime > input.id-product")[0].value;

          var total = $(this).prop("totalCans");
          total = total ? parseFloat(total.toString().replace(/[^0-9\.]*/ig,'')) : 0;
          if(total > 0){
          var params = {
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    id: id,
                    quantity: total
                  },
                  success:(cart)=>{
                    window.location.reload( );
                  }
                }
            jQuery.ajax(params);
            $(this).css('display', 'none');
          }
         });

        $(this).find("span.close").click(()=>{
          $(this).trigger("lateral-right-close");
          $(this).css('display', 'none');
        });

        $(this).submit((e) => {
          $(this).find('.resul').css('display','inline-block')
          $(this).find('.results--text').text('');
          $(this).find('.results--quantity').text('');
          $(this).find('.results--title').text('');
          var ounceCans =   $(this).find("div.noTime > input.weight")[0].value;
          var grxOz =   $(this).find("div.noTime > input.grxOz")[0].value;
          var timeWeeks = $(this).find("div.noTime > div > input").val();
          var dailyPortion = $(this).find("div.take > div > input").val();
          var ouncesPortion = $(this).find("div.milliliters > div > input").val();
          ounceCans = ounceCans ? parseFloat(ounceCans.replace(/[^0-9\.]*/ig,'')) : 0;
          grxOz = grxOz ? parseFloat(grxOz.replace(/[^0-9\.]*/ig,'')) : 0;
          timeWeeks = timeWeeks ? parseFloat(timeWeeks.replace(/[^0-9\.]*/ig,''))*7 : 0;
          dailyPortion = dailyPortion ? parseFloat(dailyPortion.replace(/[^0-9\.]*/ig,'')) : 0;
          ouncesPortion = ouncesPortion ? parseFloat(ouncesPortion.replace(/[^0-9\.]*/ig,'')) : 0;
          var total = Math.ceil((ouncesPortion * dailyPortion * timeWeeks * grxOz)/ounceCans);
          $(this).prop("totalCans",total);
          var catenation = total+" - Packs";
          $(this).find('.resul').css('display','inline-block')
          $(this).find('.results--text').text('Necesitarás:');
          $(this).find('.results--quantity').text(catenation);
          $(this).find('.results--title').append(title);
          $(this).find('article > form > div.colum > input.btnAddToCart').css('display','block');
          e.preventDefault();
          e.stopPropagation();
        });
        $(this).bind("openCalculator",(e)=>{
          $(this).css('display', 'block');
          setTimeout(()=>{ $(this).find("article").addClass('active'); }, 300);
          e.preventDefault();
          e.stopPropagation();
        });

     };
     $.fn.openCalculator = function(calculator){
       $(document).bind("toogleVariant",(e, data)=>{
         let {variant, options} = data;
         let weight = options[0] === 'Peso' ? variant.options[0] : variant.weight;
        $(calculator).find('input.weight').val(weight);
        $(calculator).find('input.id-product').val(variant.id);
        $(calculator).find('div.img > img').prop('src',variant.featured_image.src);
       });
        $(this).click((e)=>{
          $(calculator).trigger("lateral-right-open");
          $(calculator).trigger("openCalculator");
          e.preventDefault();
          e.stopPropagation();
        })
     }
  })(jQuery)
 $(".calculator-formula").calculator();
 $("#calculate").openCalculator($(".calculator-formula"));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chocomilk-banner-collection"] && !Shopify.designMode) return;
  try {
    
    const product_carousel = {
        changeSlider: (reversa) => {
            reversa = typeof(reversa) === 'boolean' ? reversa : false;

            const total_blocks = $('.product-simple-slider__item').length;
            const visible_block = $('.product-simple-slider__item:visible');
            let visible_position = visible_block.data('position');

            if(reversa){
                visible_position = visible_position - 1 <= 0 ? total_blocks : visible_position - 1;
                
            } else {
                visible_position = visible_position + 1 > total_blocks ? 1 : visible_position + 1;
            }

            visible_block.fadeOut(1000, "linear", () => {
                $(".product-simple-slider__item[data-position='"+visible_position+"']").fadeIn(1000);
            });
        },
    };

    setInterval(e=>{
        product_carousel.changeSlider();
    }, 7500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-styles"]) return;
  try {
    
$(".faq").find("li").click(function(){
    $(this).find(".enfa_answer").show();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter-inputs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }

  (function ($) {
    $.fn.genericFunction = function () {
      $(this).each(function (index) {
        window.onload = ()=> {
          $(this).find(".btn-register").on("click", (e)=> {
            e.preventDefault();
            e.stopPropagation();
            var d = new Date();
            var date = d.getFullYear()+"-"+('0'+(d.getMonth()+1).toString()).slice(-2,3)+"-"+('0'+(d.getDate()+0).toString())+" "+('0'+(d.getHours()+0).toString())+":"+('0'+(d.getMinutes()+0).toString())+":"+('0'+(d.getSeconds()+0).toString());
            var dateTimeZone = new Date().toISOString()
            const payload = {
              "FirstName": $(this).find("#name").val(),
              "LastName": $(this).find("#last-name").val(),
              "LanguageCode": "SPA",
              "Emails": [
                {
                  "EmailAddress": $(this).find("#email").val(),
                  "DeliveryStatus": "G"
                }
              ],
              "SourceCode": "MJNMEXWEB",
              "EnrollmentStatus": "A",
              "EnrollChannelCode": "WEB",
              "TierCode": "MJNMEXTIER1",
              "JsonExternalData": {
                "Agreements": [
                  {
                    "BusinessId": "LT-TC-MX-es-Enfagrow-TermsOfUseGoldenPromo ",
                    "RevisionId": "60fffe67ecc88500017b5554",
                    "ConsentAcceptedInd": true,
                    "ConsentDesc": "TermsAndConditions",
                    "MandatoryInd": true,
                    "AgreementDate": date,
                    "ActivityDate": dateTimeZone,
                    "Status": "A"
                  },
                  {
                    "BusinessId": "LT-PP-MX-es-Enfagrow-PrivacyPolicyGoldenPromo",
                    "RevisionId": "60fffe67207a4c0001942941",
                    "ConsentAcceptedInd": true,
                    "ConsentDesc": "PrivacyPolicy",
                    "MandatoryInd": true,
                    "AgreementDate": date,
                    "ActivityDate": dateTimeZone,
                    "Status": "A"
                  }
                ],
                "ProfileSubscriptions": [
                  {
                    "SubscriptionId": "882ddb48-dc46-42f7-8a17-8c9a12247084",
                    "OptSource": "WEB",
                    "ChannelCode": "EM",
                    "OptStatus": true,
                    "ActivityDate": dateTimeZone,
                    "Status": "A",
                    "JsonExternalData": {
                      "ContactPointValue": $(this).find("#email").val(),
                      "EmailOptFlag": "Y"
                    }
                  }
                ],
                "UnmappedAttributes": {
                  "TestAttribute": "test123"
                },
                "ProfileActivity": {
                  "ActivityInput": {},
                  "ActivityType": "REGISTRATION",
                  "Status": "A",
                  "DataSourceCode": "MJNMEXAPP2021",
                  "JsonExternalData": {
                    "ActivityDate": dateTimeZone,
                    "CountryCode": "SPA"
                  }
                },
                "UtmAttributes": [
                  {
                    "CampaignSource": "Web Enfapromo",
                    "CampaignMedium": "WEB",
                    "CampaignName": "Enfapromo",
                    "CampaignTerm": "",
                    "CampaignContent": "From site registration link",
                    "ActivityDate": dateTimeZone,
                    "Status": "A",
                    "UtmCampaign": "",
                    "UtmSource": "",
                    "CDPAutoGenerateInd": ""
                  }
                ]
              }
            };
            $.ajax({
              method: "POST",
              url: "https://mexicoapi.servicios-sodigitalglobal.com/user",
              dataType: "json",
              contentType: "application/json",
              data: JSON.stringify(payload),
              success : ()=> {
                $(this).css('display','none');
                $(this).modal('hide');
              },
              error: ()=> {

              }
            });
            return false;
          });

          $(this).find(".btn-close").on("click", ()=> {
              $(this).modal('hide');
          });

          $(this).find(".close-modal").on("click", ()=> {
              $(this).modal('hide');
          });

          if( getCookie('PopUp') == 'register' ){
            $(this).modal('hide');
          } else {
            setTimeout(()=> {
              $(this).modal('show');
              $(this).modal({ backdrop: 'static', keyboard: false });
              $(this).toggle();
            }, 2000);

            setCookie('PopUp Input','register', 1);
          }
        };
      });
    }
  })(jQuery);

  jQuery(document).ready(function () {
    jQuery('#popup-newsletter').genericFunction();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter"] && !Shopify.designMode) return;
  try {
    
    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    var checkIfShow = function() {
        return document.cookie.indexOf('TYEnroll') !== -1 || document.cookie.indexOf('DialogPromo') !== -1
    }
    window.onload = function () {

        $("#popup-newsletter .btn-register").on("click", function () {
            window.location = "/account/register";
        });
        $("#popup-newsletter .btn-close").on("click", function () {
            document.cookie = 'DialogPromo=' + window.location.pathname + ';';
            $('#popup-newsletter').modal('hide');
        });
        $("#popup-newsletter .close-modal").on("click", function () {
            document.cookie = 'DialogPromo=' + window.location.pathname + ';';
            $('#popup-newsletter').modal('hide');
        });


        if( getCookie('PopUp') == 'register' ){
            $('#popup-newsletter').modal('hide');
        } else {
            setTimeout(function(){
                $('#popup-newsletter').modal({ backdrop: 'static', keyboard: false });
                $('#popup-newsletter').toggle();

            }, 2000);
            setCookie('PopUp','register', 1);
        }
    };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-video-carousel"] && !Shopify.designMode) return;
  try {
    
    const video_carousel = {
        autoplay:   ($('.video-carousel').data('autoplay') && $('.video-carousel__block').length > 1),
        speed:      ($('.video-carousel').data('speed')) * 1000,
        staticsize: $('.video-carousel').data('staticsize'),

        changeSlider: (reversa) => {
            reversa = typeof(reversa) === 'boolean' ? reversa : false;

            const total_blocks = $('.video-carousel__block').length;
            const visible_block = $('.video-carousel__block:visible');
            let visible_position = visible_block.data('position');

            if(reversa){
                visible_position = visible_position - 1 <= 0 ? total_blocks : visible_position - 1;

            } else {
                visible_position = visible_position + 1 > total_blocks ? 1 : visible_position + 1;
            }

            visible_block.fadeOut(1000, "linear", () => {
                $(`.video-carousel__block[data-position=${visible_position}]`).fadeIn(1000);
            });
        },
    };

    $('.video-carousel--prev').click(() => {
        clearInterval(autoplay);
        video_carousel.changeSlider(true);
    });

    $('.video-carousel--next').click(() => {
        clearInterval(autoplay);
        video_carousel.changeSlider();
    });

    const autoplay = setInterval(() => {
        video_carousel.changeSlider();
    }, video_carousel.speed);


    if(video_carousel.autoplay === 0){
        clearInterval(autoplay);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vela-template-cart"]) return;
  try {
    

(($)=>{
  const giftingFuncts={
    getCart:function(){
      return new Promise((resolve,reject)=>{
        if(typeof (Shopify) !== "undefined"&&Shopify.cart){
          resolve(Shopify.cart);
        }else{
          $.get("/cart.js",(cart)=>{
            Shopify.cart = cart;
            resolve(Shopify.cart);
          }).fail((err)=>{
            if(err.status==200){
              try{
                let cart=JSON.parse(err.responseText);
                Shopify.cart = cart;
                resolve(Shopify.cart);
              }catch(e){
                console.error("error carrito 2",err)
              }
            }else{
              reject("no se puede crear carrito");
            }
          });
        }
      });
    },
    classifyCart:function(cart){
      return new Promise((resolve,reject)=>{
        let resps={
          main:[],
          rewards:[]
        };
        if(!cart.items){
          reject("no items");
        }else{
          for(let i in cart.items){
            if(cart.items[i].final_price==0){
              resps.rewards.push(cart.items[i].variant_id);
            }else{
              resps.main.push({
                id:cart.items[i].variant_id,
                quantity:cart.items[i].quantity,
                line_price:cart.items[i].line_price
              });
            }
          }
          resolve(resps);
        }
      });
    },
    getPromotions:function(items){
      return new Promise((resolve,reject)=>{
        if(!items||items.length<1){
          reject("no hay productos");
        }else{
          const payload = {
            line_items: items
          };
          $.ajax({
            type: "POST",
            url: "https://mexicoapi.servicios-sodigitalglobal.com/update-cart",
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify(payload),
            success: (resp)=>{
              resolve(resp.promotions);
            },
            error:(err)=>{
              reject(err);
            }
          });
        }
      });
    },
    isInCart:function(product){      
      return new Promise((resolve,reject) => {
        if(Shopify.cart) {
          if(product.data) {
            let cart_includes_product = false;
            Shopify.cart.items.map(item=>{
              if(+item.id===+product.data.id){
                cart_includes_product = item;
              }
            });
            resolve(cart_includes_product);

          } else {
            reject();
          }
        } else {
          reject('no existe carrito');
        }
      });
    },
    checkGroup(group){
      return new Promise((resolve,reject) => {
        const checks = [];
        for(let i in group.items){
          checks.push(giftingFuncts.isInCart(group.items[i]));
        }
        Promise.all(checks).then( 
          results => {
            if(results.length > 0){
              const products = {};
              for(let k in results){
                if(results[k]){
                  products[results[k].id]=results[k];
                }
              }
              if(group.union == "OR"){
                for(let j in results){
                  if(results[j]){
                    return resolve(products);
                  }
                }
                return resolve(false);
              }else{
                for(let j in results){
                  if(!results[j]){
                    return resolve(false);
                  }
                }
                return resolve(products);
              }
            }else{
              resolve(false);
            }
          }
        );
      });
    },
    parseGroups(requires){
      const grupos = {};
      for(let i in requires){
        if(!grupos[i]){
          grupos[i]= {
            id: i,
            union: requires[i][0].join,
            items: requires[i]
          };
        }
      }
      return grupos;
    },
    checkPromotion(promotion){
      return new Promise(( resolve, reject) => {
        const groups = giftingFuncts.parseGroups(promotion.required);
        const confirms = [];
        let totalComprado = 0;
        for(let i in groups){
          confirms.push(giftingFuncts.checkGroup(groups[i]));
        }
        Promise.all(confirms).then((results)=>{
            let requiredsAdded = false;
            results.map(r => {
              if(r){
                let total = 0;
                for(let j in r){
                  total += r[j].final_line_price/100;
                }
                requiredsAdded = true;
                const max = parseFloat(promotion.price_max);
                const min = parseFloat(promotion.price_min);
                if(!isNaN(max) && max > 0 && total > max){
                  requiredsAdded = false;
                }
                if(!isNaN(min) && min > 0 && total < min){
                  requiredsAdded = false;
                }
              }
            });

            if(requiredsAdded){
              resolve(promotion);
            }else{
              resolve(null);
            }
        });
      });
    }
  };
  $.fn.gifting=function(){
    giftingFuncts.getCart().then(
      cart=>{
        giftingFuncts.classifyCart(cart).then(
          cart=>{
            giftingFuncts.getPromotions(cart.main).then(
              async promotions=>{ 
                $(document).trigger("show-wait-rewards", true);
                var newRewards=[];
                var deleteRewards=[];
                var allRewards={};
                var rewardsToSelect={};
                var requiredsAdded=false;
                var addedRewardsGroups=[];
                var addedRequiredGroups=[];

                if(!promotions || promotions.length < 1){
                  return $(document).trigger("show-wait-rewards", false );
                }

                const aplicables = [];

                for(let i in promotions){
                  aplicables.push(giftingFuncts.checkPromotion(promotions[i]));
                }

                Promise.all(aplicables).then(
                  async promos => {

                    var allRewards={};
                    var addedRewardsGroups=[];
                    var rewardsToSelect={};

                    for(let i in promos){
                      if(promos[i]){
                        for(let j in promos[i].rewards){
                          await giftingFuncts.isInCart(promos[i].rewards[j]).then(
                            inCart => {
                              if(promos[i].rewards[j].join === 'AND'){
                                allRewards[promos[i].rewards[j].data.id] = promos[i].rewards[j];
                              }
                              else if(promos[i].rewards[j].join === 'OR' && inCart){
                                allRewards[promos[i].rewards[j].data.id] = promos[i].rewards[j];
                                addedRewardsGroups.push(promos[i].rewards[j].group);
                              } 
                              else if(!addedRewardsGroups.includes(promos[i].rewards[j].group)) {
                                rewardsToSelect[promos[i].rewards[j].data.id] = promos[i].rewards[j];
                              }
                            }
                          );
                        }
                      }
                    }


                    if(Object.entries(rewardsToSelect).length > 0){
                        for(let i in rewardsToSelect){
                            if(addedRewardsGroups.includes(rewardsToSelect[i].group)) {
                                delete rewardsToSelect[i];
                            }
                        }
                    }

                    for(let i in allRewards){
                      if(!cart.rewards.find((k)=>{
                        return k==allRewards[i].data.id;
                      })){
                        newRewards.push(allRewards[i]);
                      }
                    }
                    for(let i in cart.rewards){
                      if(!allRewards[cart.rewards[i]]){
                        deleteRewards.push(cart.rewards[i]);
                      }
                    }
                    if((deleteRewards.length>0 || newRewards.length>0) && Object.keys(rewardsToSelect).length<1){
                      let updates={};
                      for(let i in deleteRewards){
                        updates[deleteRewards[i]]=0;
                      }
                      for(let i in newRewards){
                        const prod_qty = newRewards[i].qty_max ? newRewards[i].qty_max : newRewards[i].qty_min;
                        updates[newRewards[i].data.id] = prod_qty ? prod_qty : 1;
                      }
                      $.post("/cart/update.js",{
                        updates:updates
                      },()=>{
                        location.reload();
                      }).fail((err)=>{
                        $(document).trigger("show-wait-rewards", false);

                        if(err.status==200){
                          location.reload();
                        }
                      });
                    } else {
                      $(document).trigger("fill-select-rewards", {rewardsToSelect, newRewards, deleteRewards});
                    }
                  }
                )
              },error=>{
                if(cart.rewards.length>0){
                  let updates={};
                  for(let i in cart.rewards){
                    updates[cart.rewards[i]] = 0;
                  }
                  $.post("/cart/update.js",{
                    updates:updates
                  },()=>{
                    location.reload();
                  }).fail((err)=>{
                    $(document).trigger("show-wait-rewards", false);
                    if(err.status==200){
                      location.reload();
                    }
                  });
                }
              }
            );
          },error=>console.error("2",error)
        );
      },error=>console.error("3 ",error)
    )
  }
})(jQuery);

$(document).ready(function () {

  $(".cartContainer").gifting();

  var loadCarrito = setInterval(function () {

    if (typeof (Shopify.cart) !== "undefined" && Shopify.cart) {

      clearInterval(loadCarrito);
      var carrito = Shopify.cart;
      var resultado = '';
      $.ajax({
        type: "POST",
        url: "https://mexicoapi.servicios-sodigitalglobal.com/cart ",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(carrito),
        success: function (resp) { 
          resultado = resp;

          var elements = [];
          var ind = 0;
          var elemento = '';

          for (let i in resp) {
            if (resp[i] && resp[i].id !== undefined) {
              elemento = '<div class="velaProBlock proFlyBlock multiple_image" data-price="' + resp[i].variants[0].price + '">' +
                '<div class="product-outline enf-slider">' +

                '<div class="proHImage">' +
                '<a class=\"proFeaturedImage\" href=\"products/' + resp[i].handle + ' " tabindex="0">' +
                '<span>' +
                '<img ' +
                ' class="img-responsive js lazyautosizes ls-is-cached lazyloaded enf_img_prev"' +
                ' datasrc=\"' + resp[i].image.src + ' \" ' +
                ' data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
                ' data-sizes="auto"' +
                ' alt=\"' + resp[i].title + '\"' +
                ' src=\"' + resp[i].image.src + ' \" ' +
                ' sizes="216px"' +
                ' />' +
                '<noscript>' +
                '<img class="img-responsive" alt=\"' + resp[i].title + '\" src=\"' + resp[i].image.src + ' \"" />' +
                '</noscript>' +
                '</span>' +
                '<img' +
                ' class=\" img-responsive imgFlyCart image-primay js lazyautosizes ls-is-cached lazyloaded\" ' +
                ' datasrc=\"' + resp[i].image.src + ' \" ' +
                ' data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                ' data-sizes="auto" ' +
                ' alt=\"' + resp[i].title + '\"' +
                ' src=\"' + resp[i].image.src + ' \"' +
                ' sizes="216px" ' +
                ' />' +
                '</a>' +
                '<p class="proAttr instock hidden">En stock</p>' +
                '</div>' +
                '<div class="proContent">' +
                '<h5 class="proName">' +
                '<a href=\"products/' + resp[i].handle + '\" tabindex=\"0\">' + resp[i].title + '</a>' +
                '</h5>' +
                '<div class="proPrice">' +
                '<div class="priceProduct priceSale">$ ' + resp[i].variants[0].price + '</div>';

              if (resp[i].variants[0].compare_at_price !== null) {
                elemento += '<div class="priceProduct priceCompare">$  ' + resp[i].variants[0].compare_at_price + '</div>'
              }
              elemento += '</div>' +
                '<div class="velaSwatchCus"></div>' +
                '</div>' +
                '<div class="formAddToCart ' + resp[i].variants[0].id + ' enf__form__sl">' +
                '<input type="hidden" name="id" value="' + resp[i].variants[0].id + '" tabindex="0" />';

              if (parseInt(resp[i].variants[0].inventory_quantity, 10) > 0) {

                elemento += '<div class="velaJsQty">' +
                  '<button type="button" class="velaQtyAdjust velaQtyAdjustMinus" data-id="" data-qty="0" tabindex="0">' +
                  '<span class="txtFallback">−</span>' +
                  '</button>' +
                  '<input type=\"text\" class=\"velaQtyNum\" value=\"1\" min=\"1\" data-id=\"\" aria-label=\"quantity\" name=\"updates[]\" tabindex=\"0\" />' +
                  '<button type="button" class="velaQtyAdjust velaQtyAdjustPlus" data-id="" data-qty="11" tabindex="0">' +
                  '<span class="txtFallback">+</span>' +
                  '</button>' +
                  '</div>' +
                  '<button class="btn  enf__add__cart btnAddToCart" type="button" tabindex="0" data-id-cart="' + resp[i].variants[0].id + '">' +
                  '<i class="ion ion-android-add"></i>' +
                  '<span>Agregar al carrito</span>' +
                  '</button>'
              } else {
                elemento +=
                  '<button class="btn btnAddToCart disabled" type="button" tabindex="0">' +
                  '<i class="ion ion-android-add"></i>' +
                  '<span>Agotado</span>' +
                  '</button>';
              }
              elemento +=
                '</div>' +
                '</div>' +
                '</div>';
              $('#featuredProducts').slick('slickAdd', $.parseHTML('<div class="product-item ">' + elemento + '</div>'));
            } //end if        
          } //endfor
        },
        error: function (resp) {
        }
      });
      return false;
    }
  }, 50);

  $('html').on('click', '.enf__form__sl .enf__add__cart', function () {
    var cant = parseInt($(this).closest('.velaProBlock').find('.velaQtyNum').val());
    var idProd = $(this).attr('data-id-cart')
    var params = {
      type: 'post',
      url: '/cart/add.js',
      data: {
        id: idProd,
        quantity: cant
      },
      complete: function () {
        window.location.reload(true);
      }
    };
    jQuery.ajax(params);
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
    const video_carousel = {
        autoplay:   ($('.video-carousel').data('autoplay') && $('.video-carousel__block').length > 1),
        speed:      ($('.video-carousel').data('speed')) * 1000,
        staticsize: $('.video-carousel').data('staticsize'),

        changeSlider: (reversa) => {
            reversa = typeof(reversa) === 'boolean' ? reversa : false;

            const total_blocks = $('.video-carousel__block').length;
            const visible_block = $('.video-carousel__block:visible');
            let visible_position = visible_block.data('position');

            if(reversa){
                visible_position = visible_position - 1 <= 0 ? total_blocks : visible_position - 1;
                
            } else {
                visible_position = visible_position + 1 > total_blocks ? 1 : visible_position + 1;
            }

            visible_block.fadeOut(1000, "linear", () => {
                $(`.video-carousel__block[data-position=${visible_position}]`).fadeIn(1000);
            });
        },
    };

    $('.video-carousel__prev-btn').click(() => {
        clearInterval(autoplay);
        video_carousel.changeSlider(true);
    });
    
    $('.video-carousel__next-btn').click(() => {
        clearInterval(autoplay);
        video_carousel.changeSlider();
    });

    const autoplay = setInterval(() => {
        video_carousel.changeSlider();
    }, video_carousel.speed);


    if(video_carousel.autoplay === 0){
        clearInterval(autoplay);
    }

  } catch(e) { console.error(e); }
})();
})();
